var render = function render(){var _vm=this,_c=_vm._self._c;return _c('goal-settings-content',{attrs:{"widget-type":"follower-goal","entity-name":"follower goal","unit":"followers"},on:{"loading":function($event){return _vm.$emit('loading', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }